module.exports = __webpack_public_path__ + "img/37.d754d61c.png";